export default {
    'it-IT': {
        language: 'Lingua',
        country: 'Nazione',
        currency: 'Valuta',
        confirm: 'Conferma',
        cancel: 'Annulla',
        visitAlso: 'Visita anche',
        welcome: 'Benvenuto',
        myProfile: 'Il mio profilo',
        myOrders: 'I miei ordini',
        logOff: 'Esci',
        logIn: 'Accedi',
        register: 'Registrati',
        help: 'Aiuto',
    },
    'fr-FR': {
        language: 'Langue',
        country: 'Pays',
        currency: 'Devise',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        visitAlso: 'Visitez aussi',
        welcome: 'Bienvenu(e)',
        myProfile: 'Mon profil',
        myOrders: 'Mes commandes',
        logOff: 'Me déconnecter',
        logIn: 'Se connecter',
        register: 'Créer un compte',
        help: 'Aide',
    },
    'es-ES': {
        language: 'Idioma',
        country: 'País',
        currency: 'Moneda',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        visitAlso: 'Visita también',
        welcome: 'Bienvenido',
        myProfile: 'Perfil',
        myOrders: 'Mis pedidos',
        logOff: 'Salir',
        logIn: 'Acceder',
        register: 'Regístrate',
        help: 'Ayuda',
    },
    'en-GB': {
        language: 'Language',
        country: 'Country',
        currency: 'Currency',
        confirm: 'Confirm',
        cancel: 'Cancel',
        visitAlso: 'Visit also',
        welcome: 'Welcome',
        myProfile: 'My account',
        myOrders: 'My orders',
        logOff: 'Log out',
        logIn: 'Login',
        register: 'Register',
        help: 'Help',
    },
    'en-US': {
        language: 'Language',
        country: 'Country',
        currency: 'Currency',
        confirm: 'Confirm',
        cancel: 'Cancel',
        visitAlso: 'Visit also',
        welcome: 'Welcome',
        myProfile: 'My account',
        myOrders: 'My orders',
        logOff: 'Log out',
        logIn: 'Login',
        register: 'Register',
        help: 'Help',
    },
    'de-DE': {
        language: 'Sprachen',
        country: 'Land',
        currency: 'Währung',
        confirm: 'Bestätigen',
        cancel: 'Abbrechen',
        visitAlso: 'Besuchen Sie auch',
        welcome: 'Willkommen',
        myProfile: 'Mein Profil',
        myOrders: 'Meine Bestellungen',
        logOff: 'Abmelden',
        logIn: 'Einloggen',
        register: 'Registrieren',
        help: 'Hilfe',
    },
    'en-AU': {
        language: 'Language',
        country: 'Country',
        currency: 'Currency',
        confirm: 'Confirm',
        cancel: 'Cancel',
        visitAlso: 'Visit also',
        welcome: 'Welcome',
        myProfile: 'My account',
        myOrders: 'My orders',
        logOff: 'Log out',
        logIn: 'Login',
        register: 'Register',
        help: 'Help',
    },
    'ko-KR': {
        language: '',
        country: '',
        currency: '',
        confirm: '',
        cancel: '',
        visitAlso: '',
        welcome: '',
        myProfile: '',
        myOrders: '',
        logOff: '',
        logIn: '',
        register: '',
        help: '',
    },
};
